import React from "react";
import "./RequestModal.css";

const keyMapping = {
    select: "Select a service",
    job: "Job Postings",
    resume: "Resume Views",
    email: "Emails Sent",
    users: "Recruiters",
    jd: "JD Creations",
    job_ai: "Job AI Usage",
    token: "Tokens",
    email_ai_usage: "Email AI Usage",
    sms_count: "SMS Sent",
    whats_app_count: "WhatsApp Messages",
    no_of_cand: "Candidates",
    email_count: "Total Emails",
};

const CustomModal = ({ isOpen, onClose, request }) => {
    if (!isOpen) return null;

    return (
        <div className="req-modal-overlay">
            <div className="req-modal-container">
                <h2 className="req-modal-title">Request needed credit</h2>
                <div className="req-modal-content">
                    <div className="req-modal-left">

                        <div className="flex-req-modal">
                            <label>Select the required service</label>
                            <select className="req-modal-select">
                                {Object.entries(keyMapping).map(([key, label]) => (
                                    <option key={key} value={label}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                            <label>Select the amount needed</label>
                            <select className="req-modal-select">
                                {[0, 10, 20, 30, 40, 50, 100, 200].map((value) => (
                                    <option key={value} value={value}>
                                        {value}
                                    </option>

                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="req-modal-buttons">
                    <button className="req-modal-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="req-modal-request-btn" onClick={request}>Request</button>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;